import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import Cleave from 'vue-cleave-component'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import './assets/scss/main.scss'

dayjs(customParseFormat)

// Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.config.devtools = true

Vue.use(Cleave)

router.beforeEach(({ name, fullPath }, from, next) => {
  if (name == 'login') {
    next()
  } else {
    store.state.user.id
      ? next()
      : store
        .dispatch('user/LOAD')
        .then(() => next())
        .catch(() => {
          next({ name: 'login', params: { fullPath } })
        })
  }
})

new Vue({ store, router, render: h => h(App) }).$mount('#app')
